//@flow
import * as React from 'react';
import classnames from 'classnames';
import defaultTheme from './Link.scss';
import { themr } from 'react-css-themr';
import { Link } from 'react-router-dom';
import popOverFactory from 'common/components/core/popover/popOverFactory';

type RouterLinkProps = {
    theme: Object,
    className?: string,
    to: string | { pathname: string, search?: string, state?: any },
    disabled?: boolean,
    testId?: string
};

class RouterLink extends React.PureComponent<RouterLinkProps> {
    static defaultProps = {
        to: ''
    };

    render() {
        const { theme, className, disabled, ...others } = this.props;
        return (
            <Link
                {...others}
                className={classnames(className, theme.linkWrap, {
                    [theme.disabled]: disabled
                })}
            />
        );
    }
}
const ThemedRouterLink = themr('LinkComponent', defaultTheme)(RouterLink);

export const routerLinkFactory = ({ LinkedComponent }) => {
    class RouterLinkComponent extends React.Component<Props> {
        render() {
            const { theme, to, target, className, ...others } = this.props;
            return (
                <ThemedRouterLink
                    to={to}
                    target={target}
                    className={className}
                    theme={theme}
                >
                    <LinkedComponent {...others} theme={theme} />
                </ThemedRouterLink>
            );
        }
    }
    return RouterLinkComponent;
};
const RouterLinkWithPopover = popOverFactory({ Component: ThemedRouterLink });

export { ThemedRouterLink as RouterLink, RouterLinkWithPopover };
export default ThemedRouterLink;
